import { useSettingsContext } from '../../theme/settings-drawer';
import { Box } from '@mui/material';
import { useMemo } from 'react';

export const HeaderAccent = () => {
  const { accentGradientColors, showAnimations } = useSettingsContext();

  const headerAccentStyle = useMemo(() => {
    if (accentGradientColors.length === 0) {
      return null;
    }

    const gradientString =
      accentGradientColors.length === 1
        ? accentGradientColors[0]
        : `linear-gradient(90deg, ${accentGradientColors.join(', ')})`;

    const baseStyle = {
      background: gradientString,
    };

    if (showAnimations) {
      return {
        ...baseStyle,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '-100%',
          width: '20%',
          height: '100%',
          background:
            'linear-gradient(90deg, transparent, rgba(255, 255, 255, 1), transparent)',
          animation: 'sheen 10s infinite',
        },
        '@keyframes sheen': {
          '0%': {
            left: '-100%',
          },
          '40%': {
            left: '100%',
          },
          '100%': {
            left: '100%',
          },
        },
      };
    }

    return baseStyle;
  }, [accentGradientColors, showAnimations]);

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        height: '8px',
        ...headerAccentStyle,
      }}
    />
  );
};
